import { FC } from 'react';

import { ChannelItem } from 'APP/main/SidebarPanel/GroupList/ChannelItem/ChannelItem';
import { GroupItem } from 'APP/main/SidebarPanel/GroupList/GroupItem/GroupItem';
import { Group } from 'STORE/Groups/Group';

interface ISpaceGroupItemProps {
  group: Group;
}

export const SpaceGroupItem: FC<ISpaceGroupItemProps> = ({ group }) => {
  return group.isChannel ? (
    <ChannelItem
      group={group}
      isShowSpaceIcon={false}
    />
  ) : (
    <GroupItem
      group={group}
      isShowSpaceIcon={false}
    />
  );
};
